export default __webpack_public_path__ + "static/media/trash.b26f512b.svg";